import React, { useState, useEffect } from 'react';
import { 
  getToken, 
  getUser, 
  isTokenValid, 
  redirectToLogin,
  authenticatedFetch
} from '../utils/tokenUtils';
import ShortLinkForm from './ShortLinkForm';

const ShortLinkEditModal = ({ 
  isOpen, 
  onClose, 
  shortLink, 
  projects, 
  onSuccess 
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [toast, setToast] = useState({ show: false, message: '', type: 'success' });

  console.log('ShortLinkEditModal props:', { isOpen, shortLink, projects });
  console.log('ShortLink details:', {
    id: shortLink?.id,
    projectId: shortLink?.projectId,
    webUrl: shortLink?.webUrl,
    androidUrl: shortLink?.androidUrl,
    iosUrl: shortLink?.iosUrl,
    title: shortLink?.title
  });

  // Toast notification functions
  const showToast = (message, type = 'success') => {
    setToast({ show: true, message, type });
    setTimeout(() => {
      setToast({ show: false, message: '', type: 'success' });
    }, 3000);
  };

  const handleUpdateShortLink = async (shortLinkId, shortLinkData) => {
    setIsSubmitting(true);
    try {
      if (!isTokenValid()) {
        redirectToLogin();
        return;
      }

      // Only allow updating URLs and title (projectId and shortCode should not change)
      const { shortCode, isActive, projectId, ...updateData } = shortLinkData;
      
      const response = await authenticatedFetch(`/api/shortlink/${shortLinkId}`, {
        method: 'PUT',
        body: updateData
      });

      const result = await response.json();
      showToast('Short link updated successfully!', 'success');
      
      // Call success callback to refresh data
      if (onSuccess) {
        await onSuccess();
      }
      
      onClose();
    } catch (error) {
      console.error('Update short link error:', error);
      if (error.message !== 'Authentication failed') {
        showToast(`Error occurred while updating short link: ${error.message}`, 'error');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen || !shortLink) return null;

  return (
    <>
      {/* Toast Notification */}
      {toast.show && (
        <div className={`fixed top-4 right-4 z-[70] px-6 py-3 rounded-lg shadow-lg transition-all duration-300 ${
          toast.type === 'success' ? 'bg-green-600 text-white' : 
          toast.type === 'info' ? 'bg-blue-600 text-white' : 
          'bg-red-600 text-white'
        }`}>
          {toast.message}
        </div>
      )}

      <ShortLinkForm
        isOpen={isOpen}
        onClose={onClose}
        onSubmit={(data) => handleUpdateShortLink(shortLink.id || shortLink._id, data)}
        shortLink={shortLink}
        projects={projects}
        isLoading={isSubmitting}
      />
    </>
  );
};

export default ShortLinkEditModal;
